import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import {
  type BaseModalFCProps,
  type ModalFC,
} from '@/components/modals/modalsManager';
import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/dialog';
import { updateStore } from '@/stores/updateStore';

interface ReleaseNotesModalProps extends BaseModalFCProps {
  version: string | undefined;
  releaseNotes: string | undefined;
}

const REMARK_PLUGINS = [remarkGfm];
export const ReleaseNotesModal: ModalFC<ReleaseNotesModalProps> = ({
  open,
  onOpenChange,
  version,
  releaseNotes,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content className="max-w-2xl max-h-[80vh] px-0">
        <Dialog.Header>
          <Dialog.Title className="text-lg px-4">
            Release Notes - v{version}
          </Dialog.Title>
        </Dialog.Header>

        <div className="overflow-y-auto max-h-[60vh] px-4">
          {
            <div className="prose prose-sm prose-bird max-w-none dark:prose-invert select-text [&_hr]:my-4 [&_hr]:border-border">
              <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>
                {releaseNotes}
              </ReactMarkdown>
            </div>
          }
        </div>

        <Dialog.Footer className="px-4">
          <Button
            onClick={() => {
              updateStore.installUpdate();
            }}
            size="sm"
          >
            Install & Restart
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
